import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RadiusAuthenticationApiService {

  private readonly radiusUrl: string = 'configuration/security/radius';
  private readonly radiusTestUrl: string = `${this.radiusUrl}/test`;

  constructor(private http: HttpClient) {}

  public getAuthenticationRadiusConfiguration(): Observable<any> {
    return this.http.get(this.radiusUrl);
  }

  public updateAuthenticationRadiusConfiguration(configuration): Observable<any> {
    return this.http.put(this.radiusUrl, configuration);
  }

  public testAuthenticationRadiusConfiguration(configuration): Observable<any> {
    return this.http.put(this.radiusTestUrl, configuration);
  }
}
